import { Outlet } from "react-router-dom";

export default function MemberOutlet() {
  return <Outlet />;
}
